import StatusMessage from 'creative-ui/uikit/StatusMessage';

import { ListItems } from '@/components/ListItems/ListItems';

export function AuthErrorBanner({ errors }: Readonly<{ errors: string[] }>) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <StatusMessage type="error" role="alert">
      {errors.length === 1 ? errors[0] : <ListItems items={errors} />}
    </StatusMessage>
  );
}
